import React from "react";
import {CustomStyleLabel} from "./Styles";
import {Box} from "@mui/material";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description CustomDescriptionModal
 * @param String id: Identifier for the label (required)
 * @param String children: Text for the label (required)
 * @returns {JSX.Element}
 */

//@Deprecated
const CustomDescriptionModal = ({labelId = "custom-label", children }) => {
    return <>
        <Box id={labelId} sx={CustomStyleLabel('normal')} className={"text-center"}>{children}</Box>
    </>
}

export default CustomDescriptionModal
